@file:OptIn(InternalResourceApi::class)

package heyagenda.shared.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/heyagenda.shared.generated.resources/"

@delegate:ResourceContentHash(-1_942_279_072)
internal val Res.drawable.brackets_curly: DrawableResource by lazy {
      DrawableResource("drawable:brackets_curly", setOf(
        ResourceItem(setOf(), "${MD}drawable/brackets_curly.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(458_141_738)
internal val Res.drawable.bread: DrawableResource by lazy {
      DrawableResource("drawable:bread", setOf(
        ResourceItem(setOf(), "${MD}drawable/bread.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_242_713_910)
internal val Res.drawable.bridge: DrawableResource by lazy {
      DrawableResource("drawable:bridge", setOf(
        ResourceItem(setOf(), "${MD}drawable/bridge.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-451_742_327)
internal val Res.drawable.briefcase: DrawableResource by lazy {
      DrawableResource("drawable:briefcase", setOf(
        ResourceItem(setOf(), "${MD}drawable/briefcase.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_698_111_396)
internal val Res.drawable.briefcase_metal: DrawableResource by lazy {
      DrawableResource("drawable:briefcase_metal", setOf(
        ResourceItem(setOf(), "${MD}drawable/briefcase_metal.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(474_798_467)
internal val Res.drawable.broadcast: DrawableResource by lazy {
      DrawableResource("drawable:broadcast", setOf(
        ResourceItem(setOf(), "${MD}drawable/broadcast.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-627_875_667)
internal val Res.drawable.broom: DrawableResource by lazy {
      DrawableResource("drawable:broom", setOf(
        ResourceItem(setOf(), "${MD}drawable/broom.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(903_485_555)
internal val Res.drawable.browser: DrawableResource by lazy {
      DrawableResource("drawable:browser", setOf(
        ResourceItem(setOf(), "${MD}drawable/browser.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-949_967_656)
internal val Res.drawable.browsers: DrawableResource by lazy {
      DrawableResource("drawable:browsers", setOf(
        ResourceItem(setOf(), "${MD}drawable/browsers.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_088_292_489)
internal val Res.drawable.bug: DrawableResource by lazy {
      DrawableResource("drawable:bug", setOf(
        ResourceItem(setOf(), "${MD}drawable/bug.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_434_863_797)
internal val Res.drawable.bug_beetle: DrawableResource by lazy {
      DrawableResource("drawable:bug_beetle", setOf(
        ResourceItem(setOf(), "${MD}drawable/bug_beetle.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_554_384_627)
internal val Res.drawable.bug_droid: DrawableResource by lazy {
      DrawableResource("drawable:bug_droid", setOf(
        ResourceItem(setOf(), "${MD}drawable/bug_droid.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_244_548_628)
internal val Res.drawable.building: DrawableResource by lazy {
      DrawableResource("drawable:building", setOf(
        ResourceItem(setOf(), "${MD}drawable/building.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_145_225_324)
internal val Res.drawable.building_apartment: DrawableResource by lazy {
      DrawableResource("drawable:building_apartment", setOf(
        ResourceItem(setOf(), "${MD}drawable/building_apartment.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-499_611_631)
internal val Res.drawable.building_office: DrawableResource by lazy {
      DrawableResource("drawable:building_office", setOf(
        ResourceItem(setOf(), "${MD}drawable/building_office.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_608_079_238)
internal val Res.drawable.calendar: DrawableResource by lazy {
      DrawableResource("drawable:calendar", setOf(
        ResourceItem(setOf(), "${MD}drawable/calendar.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_922_238_381)
internal val Res.drawable.calendar_blank: DrawableResource by lazy {
      DrawableResource("drawable:calendar_blank", setOf(
        ResourceItem(setOf(), "${MD}drawable/calendar_blank.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-935_632_013)
internal val Res.drawable.calendar_check: DrawableResource by lazy {
      DrawableResource("drawable:calendar_check", setOf(
        ResourceItem(setOf(), "${MD}drawable/calendar_check.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_584_439_710)
internal val Res.drawable.calendar_dots: DrawableResource by lazy {
      DrawableResource("drawable:calendar_dots", setOf(
        ResourceItem(setOf(), "${MD}drawable/calendar_dots.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_592_571_774)
internal val Res.drawable.calendar_heart: DrawableResource by lazy {
      DrawableResource("drawable:calendar_heart", setOf(
        ResourceItem(setOf(), "${MD}drawable/calendar_heart.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_567_184_748)
internal val Res.drawable.calendar_minus: DrawableResource by lazy {
      DrawableResource("drawable:calendar_minus", setOf(
        ResourceItem(setOf(), "${MD}drawable/calendar_minus.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_693_495_253)
internal val Res.drawable.calendar_plus: DrawableResource by lazy {
      DrawableResource("drawable:calendar_plus", setOf(
        ResourceItem(setOf(), "${MD}drawable/calendar_plus.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_277_221_156)
internal val Res.drawable.calendar_slash: DrawableResource by lazy {
      DrawableResource("drawable:calendar_slash", setOf(
        ResourceItem(setOf(), "${MD}drawable/calendar_slash.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_885_476_811)
internal val Res.drawable.calendar_star: DrawableResource by lazy {
      DrawableResource("drawable:calendar_star", setOf(
        ResourceItem(setOf(), "${MD}drawable/calendar_star.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_221_554_987)
internal val Res.drawable.calendar_x: DrawableResource by lazy {
      DrawableResource("drawable:calendar_x", setOf(
        ResourceItem(setOf(), "${MD}drawable/calendar_x.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(940_544_763)
internal val Res.drawable.call_bell: DrawableResource by lazy {
      DrawableResource("drawable:call_bell", setOf(
        ResourceItem(setOf(), "${MD}drawable/call_bell.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-744_926_719)
internal val Res.drawable.camera_plus: DrawableResource by lazy {
      DrawableResource("drawable:camera_plus", setOf(
        ResourceItem(setOf(), "${MD}drawable/camera_plus.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_577_828_393)
internal val Res.drawable.camera_rotate: DrawableResource by lazy {
      DrawableResource("drawable:camera_rotate", setOf(
        ResourceItem(setOf(), "${MD}drawable/camera_rotate.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(612_737_853)
internal val Res.drawable.camera_slash: DrawableResource by lazy {
      DrawableResource("drawable:camera_slash", setOf(
        ResourceItem(setOf(), "${MD}drawable/camera_slash.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_877_966_619)
internal val Res.drawable.caret_circle_double_down: DrawableResource by lazy {
      DrawableResource("drawable:caret_circle_double_down", setOf(
        ResourceItem(setOf(), "${MD}drawable/caret_circle_double_down.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(730_270_469)
internal val Res.drawable.caret_circle_double_left: DrawableResource by lazy {
      DrawableResource("drawable:caret_circle_double_left", setOf(
        ResourceItem(setOf(), "${MD}drawable/caret_circle_double_left.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_002_183_559)
internal val Res.drawable.caret_circle_double_right: DrawableResource by lazy {
      DrawableResource("drawable:caret_circle_double_right", setOf(
        ResourceItem(setOf(), "${MD}drawable/caret_circle_double_right.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_826_016_575)
internal val Res.drawable.caret_circle_double_up: DrawableResource by lazy {
      DrawableResource("drawable:caret_circle_double_up", setOf(
        ResourceItem(setOf(), "${MD}drawable/caret_circle_double_up.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-981_919_447)
internal val Res.drawable.caret_circle_down: DrawableResource by lazy {
      DrawableResource("drawable:caret_circle_down", setOf(
        ResourceItem(setOf(), "${MD}drawable/caret_circle_down.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_972_554_106)
internal val Res.drawable.caret_circle_left: DrawableResource by lazy {
      DrawableResource("drawable:caret_circle_left", setOf(
        ResourceItem(setOf(), "${MD}drawable/caret_circle_left.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_235_272_219)
internal val Res.drawable.caret_circle_right: DrawableResource by lazy {
      DrawableResource("drawable:caret_circle_right", setOf(
        ResourceItem(setOf(), "${MD}drawable/caret_circle_right.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_168_661_206)
internal val Res.drawable.caret_circle_up: DrawableResource by lazy {
      DrawableResource("drawable:caret_circle_up", setOf(
        ResourceItem(setOf(), "${MD}drawable/caret_circle_up.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_764_623_037)
internal val Res.drawable.caret_circle_up_down: DrawableResource by lazy {
      DrawableResource("drawable:caret_circle_up_down", setOf(
        ResourceItem(setOf(), "${MD}drawable/caret_circle_up_down.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_995_289_847)
internal val Res.drawable.caret_double_down: DrawableResource by lazy {
      DrawableResource("drawable:caret_double_down", setOf(
        ResourceItem(setOf(), "${MD}drawable/caret_double_down.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(45_211_609)
internal val Res.drawable.caret_double_left: DrawableResource by lazy {
      DrawableResource("drawable:caret_double_left", setOf(
        ResourceItem(setOf(), "${MD}drawable/caret_double_left.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(404_495_375)
internal val Res.drawable.caret_double_right: DrawableResource by lazy {
      DrawableResource("drawable:caret_double_right", setOf(
        ResourceItem(setOf(), "${MD}drawable/caret_double_right.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_303_307_563)
internal val Res.drawable.caret_double_up: DrawableResource by lazy {
      DrawableResource("drawable:caret_double_up", setOf(
        ResourceItem(setOf(), "${MD}drawable/caret_double_up.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-675_257_622)
internal val Res.drawable.caret_down: DrawableResource by lazy {
      DrawableResource("drawable:caret_down", setOf(
        ResourceItem(setOf(), "${MD}drawable/caret_down.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_030_980_456)
internal val Res.drawable.cash_register: DrawableResource by lazy {
      DrawableResource("drawable:cash_register", setOf(
        ResourceItem(setOf(), "${MD}drawable/cash_register.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-2_022_332_427)
internal val Res.drawable.cassette_tape: DrawableResource by lazy {
      DrawableResource("drawable:cassette_tape", setOf(
        ResourceItem(setOf(), "${MD}drawable/cassette_tape.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-799_867_233)
internal val Res.drawable.castle_turret: DrawableResource by lazy {
      DrawableResource("drawable:castle_turret", setOf(
        ResourceItem(setOf(), "${MD}drawable/castle_turret.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_401_459_499)
internal val Res.drawable.cat: DrawableResource by lazy {
      DrawableResource("drawable:cat", setOf(
        ResourceItem(setOf(), "${MD}drawable/cat.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-877_031_410)
internal val Res.drawable.cell_signal_full: DrawableResource by lazy {
      DrawableResource("drawable:cell_signal_full", setOf(
        ResourceItem(setOf(), "${MD}drawable/cell_signal_full.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(790_831_283)
internal val Res.drawable.cell_signal_high: DrawableResource by lazy {
      DrawableResource("drawable:cell_signal_high", setOf(
        ResourceItem(setOf(), "${MD}drawable/cell_signal_high.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-155_281_018)
internal val Res.drawable.cell_signal_low: DrawableResource by lazy {
      DrawableResource("drawable:cell_signal_low", setOf(
        ResourceItem(setOf(), "${MD}drawable/cell_signal_low.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(410_269_194)
internal val Res.drawable.cell_signal_medium: DrawableResource by lazy {
      DrawableResource("drawable:cell_signal_medium", setOf(
        ResourceItem(setOf(), "${MD}drawable/cell_signal_medium.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(654_493_200)
internal val Res.drawable.cell_signal_none: DrawableResource by lazy {
      DrawableResource("drawable:cell_signal_none", setOf(
        ResourceItem(setOf(), "${MD}drawable/cell_signal_none.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_974_458_858)
internal val Res.drawable.cell_signal_slash: DrawableResource by lazy {
      DrawableResource("drawable:cell_signal_slash", setOf(
        ResourceItem(setOf(), "${MD}drawable/cell_signal_slash.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(773_264_028)
internal val Res.drawable.cell_signal_x: DrawableResource by lazy {
      DrawableResource("drawable:cell_signal_x", setOf(
        ResourceItem(setOf(), "${MD}drawable/cell_signal_x.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(152_573_162)
internal val Res.drawable.cell_tower: DrawableResource by lazy {
      DrawableResource("drawable:cell_tower", setOf(
        ResourceItem(setOf(), "${MD}drawable/cell_tower.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_325_820_430)
internal val Res.drawable.certificate: DrawableResource by lazy {
      DrawableResource("drawable:certificate", setOf(
        ResourceItem(setOf(), "${MD}drawable/certificate.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-2_072_964_658)
internal val Res.drawable.chair: DrawableResource by lazy {
      DrawableResource("drawable:chair", setOf(
        ResourceItem(setOf(), "${MD}drawable/chair.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-912_209_251)
internal val Res.drawable.chart: DrawableResource by lazy {
      DrawableResource("drawable:chart", setOf(
        ResourceItem(setOf(), "${MD}drawable/chart.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_618_764_594)
internal val Res.drawable.chart_line: DrawableResource by lazy {
      DrawableResource("drawable:chart_line", setOf(
        ResourceItem(setOf(), "${MD}drawable/chart_line.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_539_632_078)
internal val Res.drawable.chart_line_up: DrawableResource by lazy {
      DrawableResource("drawable:chart_line_up", setOf(
        ResourceItem(setOf(), "${MD}drawable/chart_line_up.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(331_791_695)
internal val Res.drawable.chart_pie_slice: DrawableResource by lazy {
      DrawableResource("drawable:chart_pie_slice", setOf(
        ResourceItem(setOf(), "${MD}drawable/chart_pie_slice.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(37_511_400)
internal val Res.drawable.chart_polar: DrawableResource by lazy {
      DrawableResource("drawable:chart_polar", setOf(
        ResourceItem(setOf(), "${MD}drawable/chart_polar.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(953_270_159)
internal val Res.drawable.chart_scatter: DrawableResource by lazy {
      DrawableResource("drawable:chart_scatter", setOf(
        ResourceItem(setOf(), "${MD}drawable/chart_scatter.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_422_552_845)
internal val Res.drawable.chat_centered: DrawableResource by lazy {
      DrawableResource("drawable:chat_centered", setOf(
        ResourceItem(setOf(), "${MD}drawable/chat_centered.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-2_000_602_900)
internal val Res.drawable.chat_centered_dots: DrawableResource by lazy {
      DrawableResource("drawable:chat_centered_dots", setOf(
        ResourceItem(setOf(), "${MD}drawable/chat_centered_dots.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-190_135_607)
internal val Res.drawable.chat_centered_slash: DrawableResource by lazy {
      DrawableResource("drawable:chat_centered_slash", setOf(
        ResourceItem(setOf(), "${MD}drawable/chat_centered_slash.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(456_365_169)
internal val Res.drawable.chat_centered_text: DrawableResource by lazy {
      DrawableResource("drawable:chat_centered_text", setOf(
        ResourceItem(setOf(), "${MD}drawable/chat_centered_text.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_411_066_561)
internal val Res.drawable.chat_circle: DrawableResource by lazy {
      DrawableResource("drawable:chat_circle", setOf(
        ResourceItem(setOf(), "${MD}drawable/chat_circle.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_363_774_914)
internal val Res.drawable.chat_circle_dots: DrawableResource by lazy {
      DrawableResource("drawable:chat_circle_dots", setOf(
        ResourceItem(setOf(), "${MD}drawable/chat_circle_dots.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-980_956_864)
internal val Res.drawable.chat_circle_slash: DrawableResource by lazy {
      DrawableResource("drawable:chat_circle_slash", setOf(
        ResourceItem(setOf(), "${MD}drawable/chat_circle_slash.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_630_710_783)
internal val Res.drawable.chat_circle_text: DrawableResource by lazy {
      DrawableResource("drawable:chat_circle_text", setOf(
        ResourceItem(setOf(), "${MD}drawable/chat_circle_text.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_303_534_001)
internal val Res.drawable.chat_dots: DrawableResource by lazy {
      DrawableResource("drawable:chat_dots", setOf(
        ResourceItem(setOf(), "${MD}drawable/chat_dots.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_816_146_822)
internal val Res.drawable.check: DrawableResource by lazy {
      DrawableResource("drawable:check", setOf(
        ResourceItem(setOf(), "${MD}drawable/check.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_129_825_560)
internal val Res.drawable.checkerboard: DrawableResource by lazy {
      DrawableResource("drawable:checkerboard", setOf(
        ResourceItem(setOf(), "${MD}drawable/checkerboard.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-195_152_377)
internal val Res.drawable.checks: DrawableResource by lazy {
      DrawableResource("drawable:checks", setOf(
        ResourceItem(setOf(), "${MD}drawable/checks.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-731_826_620)
internal val Res.drawable.cheers: DrawableResource by lazy {
      DrawableResource("drawable:cheers", setOf(
        ResourceItem(setOf(), "${MD}drawable/cheers.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_820_513_772)
internal val Res.drawable.cheese: DrawableResource by lazy {
      DrawableResource("drawable:cheese", setOf(
        ResourceItem(setOf(), "${MD}drawable/cheese.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-496_139_537)
internal val Res.drawable.cherries: DrawableResource by lazy {
      DrawableResource("drawable:cherries", setOf(
        ResourceItem(setOf(), "${MD}drawable/cherries.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_036_511_874)
internal val Res.drawable.church: DrawableResource by lazy {
      DrawableResource("drawable:church", setOf(
        ResourceItem(setOf(), "${MD}drawable/church.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-2_103_785_171)
internal val Res.drawable.cigarette: DrawableResource by lazy {
      DrawableResource("drawable:cigarette", setOf(
        ResourceItem(setOf(), "${MD}drawable/cigarette.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(234_855_940)
internal val Res.drawable.cigarette_slash: DrawableResource by lazy {
      DrawableResource("drawable:cigarette_slash", setOf(
        ResourceItem(setOf(), "${MD}drawable/cigarette_slash.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(177_978_245)
internal val Res.drawable.circle_dashed: DrawableResource by lazy {
      DrawableResource("drawable:circle_dashed", setOf(
        ResourceItem(setOf(), "${MD}drawable/circle_dashed.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_262_622_644)
internal val Res.drawable.circle_half: DrawableResource by lazy {
      DrawableResource("drawable:circle_half", setOf(
        ResourceItem(setOf(), "${MD}drawable/circle_half.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(143_488_590)
internal val Res.drawable.circle_half_tilt: DrawableResource by lazy {
      DrawableResource("drawable:circle_half_tilt", setOf(
        ResourceItem(setOf(), "${MD}drawable/circle_half_tilt.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_562_302_856)
internal val Res.drawable.circle_notch: DrawableResource by lazy {
      DrawableResource("drawable:circle_notch", setOf(
        ResourceItem(setOf(), "${MD}drawable/circle_notch.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(443_844_411)
internal val Res.drawable.circles_three: DrawableResource by lazy {
      DrawableResource("drawable:circles_three", setOf(
        ResourceItem(setOf(), "${MD}drawable/circles_three.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_517_797_044)
internal val Res.drawable.circuitry: DrawableResource by lazy {
      DrawableResource("drawable:circuitry", setOf(
        ResourceItem(setOf(), "${MD}drawable/circuitry.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_473_298_085)
internal val Res.drawable.city: DrawableResource by lazy {
      DrawableResource("drawable:city", setOf(
        ResourceItem(setOf(), "${MD}drawable/city.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(723_866_721)
internal val Res.drawable.clipboard: DrawableResource by lazy {
      DrawableResource("drawable:clipboard", setOf(
        ResourceItem(setOf(), "${MD}drawable/clipboard.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-359_714_781)
internal val Res.drawable.clipboard_text: DrawableResource by lazy {
      DrawableResource("drawable:clipboard_text", setOf(
        ResourceItem(setOf(), "${MD}drawable/clipboard_text.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(511_182_056)
internal val Res.drawable.clock: DrawableResource by lazy {
      DrawableResource("drawable:clock", setOf(
        ResourceItem(setOf(), "${MD}drawable/clock.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_117_900_168)
internal val Res.drawable.clock_afternoon: DrawableResource by lazy {
      DrawableResource("drawable:clock_afternoon", setOf(
        ResourceItem(setOf(), "${MD}drawable/clock_afternoon.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_049_343_717)
internal val Res.drawable.clock_clockwise: DrawableResource by lazy {
      DrawableResource("drawable:clock_clockwise", setOf(
        ResourceItem(setOf(), "${MD}drawable/clock_clockwise.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-2_116_187_525)
internal val Res.drawable.clock_countdown: DrawableResource by lazy {
      DrawableResource("drawable:clock_countdown", setOf(
        ResourceItem(setOf(), "${MD}drawable/clock_countdown.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_078_923_819)
internal val Res.drawable.clock_counter_clockwise: DrawableResource by lazy {
      DrawableResource("drawable:clock_counter_clockwise", setOf(
        ResourceItem(setOf(), "${MD}drawable/clock_counter_clockwise.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(109_918_646)
internal val Res.drawable.clock_user: DrawableResource by lazy {
      DrawableResource("drawable:clock_user", setOf(
        ResourceItem(setOf(), "${MD}drawable/clock_user.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(473_535_352)
internal val Res.drawable.closed_captioning: DrawableResource by lazy {
      DrawableResource("drawable:closed_captioning", setOf(
        ResourceItem(setOf(), "${MD}drawable/closed_captioning.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-2_104_943_213)
internal val Res.drawable.cloud: DrawableResource by lazy {
      DrawableResource("drawable:cloud", setOf(
        ResourceItem(setOf(), "${MD}drawable/cloud.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(416_546_266)
internal val Res.drawable.cloud_arrow_down: DrawableResource by lazy {
      DrawableResource("drawable:cloud_arrow_down", setOf(
        ResourceItem(setOf(), "${MD}drawable/cloud_arrow_down.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_694_440_958)
internal val Res.drawable.cloud_arrow_up: DrawableResource by lazy {
      DrawableResource("drawable:cloud_arrow_up", setOf(
        ResourceItem(setOf(), "${MD}drawable/cloud_arrow_up.xml", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable2Resources(map: MutableMap<String, DrawableResource>) {
  map.put("brackets_curly", Res.drawable.brackets_curly)
  map.put("bread", Res.drawable.bread)
  map.put("bridge", Res.drawable.bridge)
  map.put("briefcase", Res.drawable.briefcase)
  map.put("briefcase_metal", Res.drawable.briefcase_metal)
  map.put("broadcast", Res.drawable.broadcast)
  map.put("broom", Res.drawable.broom)
  map.put("browser", Res.drawable.browser)
  map.put("browsers", Res.drawable.browsers)
  map.put("bug", Res.drawable.bug)
  map.put("bug_beetle", Res.drawable.bug_beetle)
  map.put("bug_droid", Res.drawable.bug_droid)
  map.put("building", Res.drawable.building)
  map.put("building_apartment", Res.drawable.building_apartment)
  map.put("building_office", Res.drawable.building_office)
  map.put("calendar", Res.drawable.calendar)
  map.put("calendar_blank", Res.drawable.calendar_blank)
  map.put("calendar_check", Res.drawable.calendar_check)
  map.put("calendar_dots", Res.drawable.calendar_dots)
  map.put("calendar_heart", Res.drawable.calendar_heart)
  map.put("calendar_minus", Res.drawable.calendar_minus)
  map.put("calendar_plus", Res.drawable.calendar_plus)
  map.put("calendar_slash", Res.drawable.calendar_slash)
  map.put("calendar_star", Res.drawable.calendar_star)
  map.put("calendar_x", Res.drawable.calendar_x)
  map.put("call_bell", Res.drawable.call_bell)
  map.put("camera_plus", Res.drawable.camera_plus)
  map.put("camera_rotate", Res.drawable.camera_rotate)
  map.put("camera_slash", Res.drawable.camera_slash)
  map.put("caret_circle_double_down", Res.drawable.caret_circle_double_down)
  map.put("caret_circle_double_left", Res.drawable.caret_circle_double_left)
  map.put("caret_circle_double_right", Res.drawable.caret_circle_double_right)
  map.put("caret_circle_double_up", Res.drawable.caret_circle_double_up)
  map.put("caret_circle_down", Res.drawable.caret_circle_down)
  map.put("caret_circle_left", Res.drawable.caret_circle_left)
  map.put("caret_circle_right", Res.drawable.caret_circle_right)
  map.put("caret_circle_up", Res.drawable.caret_circle_up)
  map.put("caret_circle_up_down", Res.drawable.caret_circle_up_down)
  map.put("caret_double_down", Res.drawable.caret_double_down)
  map.put("caret_double_left", Res.drawable.caret_double_left)
  map.put("caret_double_right", Res.drawable.caret_double_right)
  map.put("caret_double_up", Res.drawable.caret_double_up)
  map.put("caret_down", Res.drawable.caret_down)
  map.put("cash_register", Res.drawable.cash_register)
  map.put("cassette_tape", Res.drawable.cassette_tape)
  map.put("castle_turret", Res.drawable.castle_turret)
  map.put("cat", Res.drawable.cat)
  map.put("cell_signal_full", Res.drawable.cell_signal_full)
  map.put("cell_signal_high", Res.drawable.cell_signal_high)
  map.put("cell_signal_low", Res.drawable.cell_signal_low)
  map.put("cell_signal_medium", Res.drawable.cell_signal_medium)
  map.put("cell_signal_none", Res.drawable.cell_signal_none)
  map.put("cell_signal_slash", Res.drawable.cell_signal_slash)
  map.put("cell_signal_x", Res.drawable.cell_signal_x)
  map.put("cell_tower", Res.drawable.cell_tower)
  map.put("certificate", Res.drawable.certificate)
  map.put("chair", Res.drawable.chair)
  map.put("chart", Res.drawable.chart)
  map.put("chart_line", Res.drawable.chart_line)
  map.put("chart_line_up", Res.drawable.chart_line_up)
  map.put("chart_pie_slice", Res.drawable.chart_pie_slice)
  map.put("chart_polar", Res.drawable.chart_polar)
  map.put("chart_scatter", Res.drawable.chart_scatter)
  map.put("chat_centered", Res.drawable.chat_centered)
  map.put("chat_centered_dots", Res.drawable.chat_centered_dots)
  map.put("chat_centered_slash", Res.drawable.chat_centered_slash)
  map.put("chat_centered_text", Res.drawable.chat_centered_text)
  map.put("chat_circle", Res.drawable.chat_circle)
  map.put("chat_circle_dots", Res.drawable.chat_circle_dots)
  map.put("chat_circle_slash", Res.drawable.chat_circle_slash)
  map.put("chat_circle_text", Res.drawable.chat_circle_text)
  map.put("chat_dots", Res.drawable.chat_dots)
  map.put("check", Res.drawable.check)
  map.put("checkerboard", Res.drawable.checkerboard)
  map.put("checks", Res.drawable.checks)
  map.put("cheers", Res.drawable.cheers)
  map.put("cheese", Res.drawable.cheese)
  map.put("cherries", Res.drawable.cherries)
  map.put("church", Res.drawable.church)
  map.put("cigarette", Res.drawable.cigarette)
  map.put("cigarette_slash", Res.drawable.cigarette_slash)
  map.put("circle_dashed", Res.drawable.circle_dashed)
  map.put("circle_half", Res.drawable.circle_half)
  map.put("circle_half_tilt", Res.drawable.circle_half_tilt)
  map.put("circle_notch", Res.drawable.circle_notch)
  map.put("circles_three", Res.drawable.circles_three)
  map.put("circuitry", Res.drawable.circuitry)
  map.put("city", Res.drawable.city)
  map.put("clipboard", Res.drawable.clipboard)
  map.put("clipboard_text", Res.drawable.clipboard_text)
  map.put("clock", Res.drawable.clock)
  map.put("clock_afternoon", Res.drawable.clock_afternoon)
  map.put("clock_clockwise", Res.drawable.clock_clockwise)
  map.put("clock_countdown", Res.drawable.clock_countdown)
  map.put("clock_counter_clockwise", Res.drawable.clock_counter_clockwise)
  map.put("clock_user", Res.drawable.clock_user)
  map.put("closed_captioning", Res.drawable.closed_captioning)
  map.put("cloud", Res.drawable.cloud)
  map.put("cloud_arrow_down", Res.drawable.cloud_arrow_down)
  map.put("cloud_arrow_up", Res.drawable.cloud_arrow_up)
}
